import { Component } from '@angular/core';

@Component({
    selector: 'pdf-prepare-printing-dialog',
    templateUrl: './pdf-prepare-printing-dialog.component.html',
    styleUrls: ['./pdf-prepare-printing-dialog.component.css'],
    standalone: false
})
export class PdfPreparePrintingDialogComponent {}
